import { getApiBaseUrl } from '../../shared/utils/apiBase';
import { UserIdentitiesMutation } from './services/mutationService';
async function CommitHandler(props) {
  const {
    addedRow,
    editedRow,
    editedRowOriginal,
    allAccessibleColumns,
    configSchema,
    userDetails,
  } = props;
  const mutationTables = getMutationTable(allAccessibleColumns);
  const allAsyncResults: any = { success: true, data: [], errors: [] };
  if (addedRow.length) {
    try {
      const reqData = rowHandler(mutationTables, addedRow);
      for (const reqDataSet of reqData) {
        const {
          usersOperationDoc,
          usersMutationVariables,
          userstopcnrOperationDoc,
          pcnrMutationVariables,
        } = formatData(reqDataSet, configSchema, userDetails?.userId);
        const { mutationResult, errors } = await UserIdentitiesMutation({
          usersOperationDoc,
          usersMutationVariables,
          configSchema,
          pcnrMutationVariables,
          userstopcnrOperationDoc,
        });
        if (errors?.length) {
          allAsyncResults.errors.push({
            message: errors[0].message,
          });
          allAsyncResults.success = false;
        }
        if (mutationResult) {
          allAsyncResults.data.push({
            message: 'successfully_updated',
          });
        }
      }
      return allAsyncResults;
    } catch (err) {
      allAsyncResults.errors.push({
        message: err.message,
      });
      allAsyncResults.success = false;
      return allAsyncResults;
    }
  }
  return editedRecordFunction(
    editedRow,
    editedRowOriginal,
    mutationTables,
    configSchema,
    userDetails,
  );
}

const editedRecordFunction = async (
  editedRow,
  editedRowOriginal,
  mutationTables,
  configSchema,
  userDetails,
) => {
  const allAsyncResults = { errors: [], success: true, data: [] };
  if (editedRow.length) {
    try {
      const editedRecord = getEditedRowLogic({
        editedRow,
        editedRowOriginal,
        operationUserId: userDetails.userId,
      });
      const reqData = rowHandler(mutationTables, editedRow);
      for (const element of reqData) {
        const reqDataSet = element;
        if (
          reqDataSet.rowData.user_account_id !==
          editedRowOriginal[reqDataSet.rowData.id].user_account_id
        ) {
          const {
            usersOperationDoc,
            usersMutationVariables,
            userstopcnrOperationDoc,
            pcnrMutationVariables,
          } = formatData(reqDataSet, configSchema, userDetails?.userId);
          const response = await addedFunctionality(
            usersOperationDoc,
            usersMutationVariables,
            userstopcnrOperationDoc,
            pcnrMutationVariables,
            configSchema,
          );
          allAsyncResults.success = response.success;
          allAsyncResults.errors = response.errors;
          allAsyncResults.data = response.data;
        } else {
          const response = await editedAndAddedRecordUpdate(
            reqDataSet,
            editedRecord,
            userDetails?.userId,
          );
          allAsyncResults.success = response.success;
          allAsyncResults.errors = response.errors;
          allAsyncResults.data = response.data;
        }
      }
      return allAsyncResults;
    } catch (error) {
      allAsyncResults.errors.push({
        message: error.message,
      });
      allAsyncResults.success = false;
      return allAsyncResults;
    }
  }
};
const addedFunctionality = async (
  usersOperationDoc,
  usersMutationVariables,
  userstopcnrOperationDoc,
  pcnrMutationVariables,
  configSchema,
) => {
  const allAsyncResults = { errors: [], success: true, data: [] };
  const { mutationResult, errors } = await UserIdentitiesMutation({
    usersOperationDoc,
    usersMutationVariables,
    configSchema,
    pcnrMutationVariables,
    userstopcnrOperationDoc,
  });
  if (errors?.length) {
    allAsyncResults.errors.push({
      message: errors[0].message,
    });
    allAsyncResults.success = false;
  }
  if (mutationResult) {
    allAsyncResults.data.push({
      message: 'successfully_updated',
    });
  }
  return allAsyncResults;
};
const editedAndAddedRecordUpdate = async (reqDataSet, editedRecord, userId) => {
  const allAsyncResults = { errors: [], success: true, data: [] };
  const mutationVariables = {
    id: reqDataSet.mbd_users.user_id,
  };
  const deletedRecord = editedRecord.delete.filter((v) => {
    return v.user_id == reqDataSet.mbd_users.user_id;
  });
  const addedRecords = editedRecord.new.filter((v) => {
    return v.user_id == reqDataSet.mbd_users.user_id;
  });
  const modUserData = editedRecord.userObject
    .map((v) => {
      if (v.user_id == reqDataSet.mbd_users.user_id) {
        const { user_id, ...rest } = v;
        if (user_id) {
          return rest;
        }
      }
    })
    .filter(Boolean);
  if (modUserData.length) {
    mutationVariables['user_objects'] = {
      ...modUserData[0],
      updated_by: userId,
      update_date: new Date().toISOString().substring(0, 19),
    };
  }
  if (deletedRecord.length) {
    mutationVariables['user_id'] = userId;
    mutationVariables['deletedPcnr'] = deletedRecord.map((v) => v.pcnr_id);
  }
  if (addedRecords.length) {
    mutationVariables['userstopcnr_objects'] = addedRecords;
  }
  const apiBase = getApiBaseUrl();
  const response = await fetch(`${apiBase}/api/updateUserIdentities`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      mutationVariables,
    }),
  });
  const { mutationResult, errors } = await response.json();
  if (errors?.length) {
    allAsyncResults.errors.push({
      message: errors[0].message,
    });
    allAsyncResults.success = false;
  }
  if (mutationResult) {
    allAsyncResults.data.push({
      message: 'successfully_updated',
    });
  }
  return allAsyncResults;
};
const formatData = (reqDataSet, configSchema, userId) => {
  const pcnrId = reqDataSet.mbd_users_to_pcnr?.pcnr_id;
  const pcnr = pcnrId?.map((v) => {
    return { pcnr_id: v, updated_by: userId };
  });
  const usersMutationVariables = {
    user_objects: { ...reqDataSet.mbd_users, updated_by: userId, created_by: userId },
  };
  delete usersMutationVariables.user_objects.user_id;
  const pcnrMutationVariables = {
    userstopcnr_objects: pcnr,
  };
  let usersOperationDoc = '';
  let userstopcnrOperationDoc = '';
  usersOperationDoc = `
          insert_${configSchema}_mbd_users(objects: $user_objects) {
              returning {
                id
              }
            }
          `;
  userstopcnrOperationDoc = `        
      insert_${configSchema}_mbd_users_to_pcnr(objects: $userstopcnr_objects) {
       returning {
          id
       }
    }`;
  return {
    usersOperationDoc,
    usersMutationVariables,
    userstopcnrOperationDoc,
    pcnrMutationVariables,
  };
};
const getMutationTable = (allAccessibleColumns) => {
  return allAccessibleColumns.reduce((resp, item) => {
    const { mutationTableName } = item;
    if (!mutationTableName) {
      return resp;
    }
    if (!resp?.[mutationTableName]) {
      resp[mutationTableName] = [];
    }
    resp[mutationTableName].push(item);
    return resp;
  }, {});
};

const rowHandler = (mutationTables, rowDetails) => {
  const reqData = rowDetails.reduce((data, item) => {
    const groupRecord = {};
    groupRecord['rowData'] = item;
    for (const key in mutationTables) {
      groupRecord[key] = mutationTables[key].reduce((resp, record) => {
        const { mutationColumnName, attrInternalName } = record;
        resp[mutationColumnName ?? attrInternalName] = item[attrInternalName];
        return resp;
      }, {});
    }
    data.push(groupRecord);
    return data;
  }, []);
  return reqData;
};
function getEditedRowLogic({ editedRow, editedRowOriginal, operationUserId }) {
  return editedRow.reduce(
    (resp, item) => {
      const { pcnr_id: pcnrIds, ...userOriginalData } = editedRowOriginal[item.id];
      const { pcnr_id: modifiedPcnr, ...userModifiedData } = item;
      const userData = {};
      for (const key in userOriginalData) {
        if (userOriginalData[key] !== userModifiedData[key]) {
          userData[key] = userModifiedData[key];
        }
      }
      if (userData) {
        userData['user_id'] = item.user_id;
      }
      const newRow = modifiedPcnr.reduce((pcnrArr, pcnrId) => {
        if (!pcnrIds.includes(pcnrId)) {
          const newRoleRow = {
            user_id: item.user_id,
            pcnr_id: pcnrId,
            created_by: operationUserId,
            updated_by: operationUserId,
            update_date: new Date().toISOString().substring(0, 19),
          };
          pcnrArr.push(newRoleRow);
        }
        return pcnrArr;
      }, []);
      const deleteRow = pcnrIds.reduce((pcnrArr, pcnrId) => {
        if (pcnrId && !modifiedPcnr.includes(pcnrId)) {
          const deleteRoleRow = { user_id: item.user_id, pcnr_id: pcnrId };
          pcnrArr.push(deleteRoleRow);
        }
        return pcnrArr;
      }, []);
      if (userData) {
        resp.userObject.push(userData);
      }
      if (newRow.length) {
        resp.new = resp.new.concat(newRow);
      }
      if (deleteRow.length) {
        resp.delete = resp.delete.concat(deleteRow);
      }
      return resp;
    },
    { new: [], delete: [], userObject: [] },
  );
}

export default CommitHandler;
